export default __webpack_public_path__ + "static/media/freckle.f7797716.png";